/* unplugin-vue-components disabled */import { render } from "./privacy.vue?vue&type=template&id=411070a0&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=411070a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411070a0"]])

export default __exports__